import { Box, Typography, Button } from "@mui/material";
import { useSolve } from "../hooks/useSolve";
import { auth } from "../config/firebase";
import { ROUND_STATUS, updatePlayerRoundSolveStatus } from "./utils/MatchUtils";
import {parseScramble} from "../components/utils/scrambles";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Alg } from "cubing/alg";
import { useScrambleProgress } from "../hooks/useScrambleProgress";
import { ICubingService, StackmatState } from "./services/ICubingService";
import { CubeCtx } from "./BluetoothCubeProvider";

interface ScrambleProps {
    matchId: string,
    roundNumber: number,
    solveNumber: number,
    onComplete: () => void
}

const Scramble: React.FC<ScrambleProps> = ({ matchId, roundNumber, solveNumber, onComplete }) => {

  const { solve, loadingSolve: loading, errorSolve: error } = useSolve(
    matchId,
    auth.currentUser?.uid!,
    roundNumber,
    solveNumber
  ); 

  const { getService } = useContext(CubeCtx);
  const service = getService(); // now kept inside the component function

  const scramble = solve?.scramble ?? "";
  const words    = useMemo(() => parseScramble(scramble), [scramble]);
  const doneIdx  = useScrambleProgress(scramble);
  const currentAlg = useRef<Alg>(new Alg())
  
  const [parsedSolve, setParsedSolve] = useState<string[]>([]);

  useEffect(()=>{
    if(solve?.scramble !== undefined){
      setParsedSolve(parseScramble(solve?.scramble))
    }
  }, [solve])

  const [moves, setMoves] = useState<string>("");

  useEffect(()=>{
    if(solve?.scramble !== undefined){
      setParsedSolve(parseScramble(solve?.scramble))
    }
  }, [solve])

  const [parsedScramble, setParsedScramble] = useState<string[]>([]);

  // useEffect(()=>{
  //   if(state.alg !== undefined){
  //     setParsedScramble(parseScramble(state.alg.toString()))
  //   }
  // }, [state])

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        bgcolor: "white", // White background
        opacity: .9,
        flexDirection: "column",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
      }}
    >
        {!loading && !!service && <>
          <Typography
            variant="h1"
            sx={{
              fontSize: "3em",
              fontFamily: "Courier New, monospace",
              fontWeight: 600,
              marginBottom: "24px",
              width: "860px",
              textAlign: "center"
              }}
          >
            {parsedSolve.join(" ")}
          </Typography>
          <Typography
            variant="h1"
            sx={{
              fontSize: "3em",
              fontFamily: "Courier New, monospace",
              fontWeight: 600,
              marginBottom: "24px",
              width: "860px",
              textAlign: "center"
              }}
          >
            {words.join(" ")}
          </Typography>
          <Typography variant="h1"
            sx={{
              fontSize: "3em",
              fontFamily: "Courier New, monospace",
              fontWeight: 600,
              marginBottom: "24px",
              width: "860px",
              textAlign: "center"
              }}>
            {words.map((tok, i) => (
              <span
                key={i}
                style={{
                  color:  i < doneIdx ? "#2e7d32" : "#000",
                }}
              >
                {tok + " "}
              </span>
            ))}
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={async ()=>{
              const isScrambled = await service.validateFacelets(new Alg(scramble))
              if(isScrambled){
                onComplete();
              } else {
                alert("The cube is not scrambled properly.")
              }
            }}
            >
            Scramble Completed
        </Button>
        </>}
    </Box>
  );
};

export default Scramble;
